/**
 * Replaces parameters in a route string with their corresponding values
 * @param route - The route string containing parameters (e.g. '/patient-directory/:patientId')
 * @param params - An object containing parameter names and their values
 * @returns The route string with parameters replaced by their values
 *
 * @example
 * replaceRouteParams('/patient-directory/:patientId', { patientId: '123' })
 * // Returns: '/patient-directory/123'
 */
export const replaceRouteParams = (route: string, params: Record<string, string | undefined>): string => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(`:${key}`, value || '')
  }, route)
}
